import { useState } from 'react';
import { ttsService, AccentType } from '../../services/tts';

interface AccentSelectorProps {
  onAccentChange?: (accent: AccentType) => void;
}

export default function AccentSelector({ onAccentChange }: AccentSelectorProps) {
  const [currentAccent, setCurrentAccent] = useState<AccentType>(ttsService.getAccent());

  const handleAccentChange = (accent: AccentType) => {
    setCurrentAccent(accent);
    ttsService.setAccent(accent);
    onAccentChange?.(accent);
  };

  const testAccent = async () => {
    try {
      // Show current voice info
      const currentVoice = ttsService.getCurrentVoice();
      console.log('🎤 Current voice:', currentVoice?.name, currentVoice?.lang);
      console.log('🇺🇸 American voice:', ttsService.getVoices().find(v => v.lang.includes('en-US')));
      console.log('🇬🇧 British voice:', ttsService.getVoices().find(v => v.lang.includes('en-GB')));

      // Test with different sentences to hear the difference
      const testSentence = currentAccent === 'american'
        ? 'Hello! I am speaking American English. The color is gray.'
        : 'Hello! I am speaking British English. The colour is grey.';

      await ttsService.speakNormal(testSentence);
    } catch (error) {
      console.error('TTS error:', error);
    }
  };

  return (
    <div className="bg-white rounded-2xl p-4 shadow-soft">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-bold text-gray-700">发音类型</h3>
        <button
          onClick={testAccent}
          className="text-sm text-primary hover:underline"
        >
          试听 🔊
        </button>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <button
          onClick={() => handleAccentChange('american')}
          className={`p-3 rounded-xl font-medium transition-all ${
            currentAccent === 'american'
              ? 'bg-blue-500 text-white shadow-lg'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <div className="flex items-center gap-2 justify-center">
            <span className="text-2xl">🇺🇸</span>
            <div className="text-left">
              <p className="font-bold">美式英语</p>
              <p className="text-xs opacity-80">American</p>
            </div>
          </div>
        </button>

        <button
          onClick={() => handleAccentChange('british')}
          className={`p-3 rounded-xl font-medium transition-all ${
            currentAccent === 'british'
              ? 'bg-purple-500 text-white shadow-lg'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <div className="flex items-center gap-2 justify-center">
            <span className="text-2xl">🇬🇧</span>
            <div className="text-left">
              <p className="font-bold">英式英语</p>
              <p className="text-xs opacity-80">British</p>
            </div>
          </div>
        </button>
      </div>

      <div className="mt-3 text-sm text-gray-500">
        <p className="text-center">
          当前：{ttsService.getAccentDisplayName()}
        </p>
        {!ttsService.hasBothAccents() && (
          <p className="text-center text-orange-500 mt-2">
            ⚠️ 系统可能不支持英式发音
          </p>
        )}
      </div>
    </div>
  );
}